/**
 * Keypad Slice
 * Manages in-call keypad state and DTMF digits
 */
import { StateCreator } from 'zustand';
import { SoftphoneStore } from '../..';
import { KeypadSlice, KeypadSliceState } from './index.types';

const initialState: KeypadSliceState = {
  isKeypadActive: false,
  keypadDigits: '',
};

export const createKeypadSlice: StateCreator<
  SoftphoneStore,
  [],
  [],
  KeypadSlice
> = (set, get) => {
  const resetState = { ...initialState };

  return {
    ...initialState,

    toggleKeypad: () => {
      const newKeypadState = !get().isKeypadActive;

      // When opening keypad, close dialpad (mutual exclusion)
      if (newKeypadState && get().isDialpadActive) {
        set({
          isDialpadActive: false,
          dialpadDigits: '',
          cursorPosition: null,
        });
      }

      set({ isKeypadActive: newKeypadState });
    },

    closeKeypad: () => {
      set({ isKeypadActive: false });
    },

    setKeypadDigits: (keypadDigits) => {
      set({ keypadDigits: keypadDigits });
    },

    deleteLastKeypadDigit: () => {
      set((state) => ({ keypadDigits: state.keypadDigits.slice(0, -1) }));
    },

    clearKeypadDigits: () => {
      set({ keypadDigits: '' });
    },

    resetKeypad: () => set(resetState),
  };
};
